import React, {Component} from 'react';
import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {LayoutSidebar} from '../../../Layout';
import {Spinner} from '../../Spinner';
import {FaIcon} from '../../FaIcon';
import {LocalStorage} from '../../../utils/LocalStorage';
import {TemplateCard} from './TemplateCard';
import {ForkTemplateModal} from './ForkTemplateModal';
import {withTranslation} from 'react-i18next';
import {withRouterParams} from '../../../utils/withRouterParams';
import './TemplateLibraryPage.scss';


class TemplateLibraryPageClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userTemplates: [],
            officialTemplates: [],
            loading: true,
            activeTab: 'mine',
            showForkModal: false,
            allAgencyClients: [],
            loadingClients: false,
        };

        this.toggleForkModal = this.toggleForkModal.bind(this);
        this.handleForkSuccess = this.handleForkSuccess.bind(this);
    }

    componentDidMount() {
        this.fetchTemplates();
    }

    fetchTemplates() {
        this.setState({loading: true});
        new APIClient(API_URL + 'reports/templates/user/?include_official=true').call('GET').then((data) => {
            if (data && data.status === 'OK') {
                const userTemplates = data.data.user_templates || [];
                const officialTemplates = data.data.official_templates || [];
                this.setState({userTemplates, officialTemplates, loading: false});
            } else {
                this.setState({loading: false});
            }
        });
    }

    fetchClients() {
        this.setState({loadingClients: true});
        new APIClient(API_URL + 'agency/clients/').call('GET').then((data) => {
            if (data && data.data) {
                this.setState({allAgencyClients: data.data, loadingClients: false});
            } else {
                this.setState({loadingClients: false});
            }
        });
    }

    toggleForkModal() {
        const opening = !this.state.showForkModal;
        this.setState({showForkModal: opening});
        if (opening && this.state.allAgencyClients.length === 0) {
            this.fetchClients();
        }
    }

    handleForkSuccess(newTemplateId) {
        this.props.navigate('/reports/templates/' + newTemplateId);
    }

    render() {
        const {t} = this.props;
        const {userTemplates, officialTemplates, loading, activeTab, showForkModal} = this.state;
        const currentUserId = LocalStorage.fetchUserId();
        const language = this.props.i18n.language;

        const myTemplates = userTemplates.filter(ut => ut.created_by && ut.created_by.id === currentUserId);
        const sharedTemplates = userTemplates.filter(ut => !ut.created_by || ut.created_by.id !== currentUserId);
        const displayedTemplates = activeTab === 'mine' ? myTemplates : sharedTemplates;

        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <header className="section-header">
                        <h1 className="section-title">{t('templates.page_title')}</h1>
                        <button className="btn -alt" onClick={this.toggleForkModal}>
                            <FaIcon iconName="plus"/>
                            {t('templates.create_from_official')}
                        </button>
                    </header>
                    <div className="section-body">
                        <div className="box template-library-box">
                            {loading ? (
                                <div className="template-library-loading">
                                    <Spinner color="positive"/>
                                </div>
                            ) : userTemplates.length === 0 ? (
                                <div className="template-library-empty">
                                    <div className="template-library-empty-icon">
                                        <FaIcon iconName="file-chart-line"/>
                                    </div>
                                    <h3 className="template-library-empty-title">{t('templates.empty_title')}</h3>
                                    <p className="template-library-empty-subtitle">{t('templates.empty_subtitle')}</p>
                                    <button className="btn -alt" onClick={this.toggleForkModal}>
                                        <FaIcon iconName="plus"/>
                                        {t('templates.empty_cta')}
                                    </button>
                                </div>
                            ) : (
                                <>
                                    <div className="template-library-tabs">
                                        <button
                                            className={`template-library-tab ${activeTab === 'mine' ? '-active' : ''}`}
                                            onClick={() => this.setState({activeTab: 'mine'})}
                                        >
                                            {t('templates.tab_mine')}
                                            {myTemplates.length > 0 && (
                                                <span className="template-library-tab-count">{myTemplates.length}</span>
                                            )}
                                        </button>
                                        <button
                                            className={`template-library-tab ${activeTab === 'shared' ? '-active' : ''}`}
                                            onClick={() => this.setState({activeTab: 'shared'})}
                                        >
                                            {t('templates.tab_shared')}
                                            {sharedTemplates.length > 0 && (
                                                <span className="template-library-tab-count">{sharedTemplates.length}</span>
                                            )}
                                        </button>
                                    </div>
                                    <div className="template-library-list">
                                        {displayedTemplates.length === 0 ? (
                                            <div className="template-library-empty -compact">
                                                <p className="template-library-empty-subtitle">
                                                    {activeTab === 'mine'
                                                        ? t('templates.empty_subtitle')
                                                        : t('templates.empty_subtitle')}
                                                </p>
                                            </div>
                                        ) : (
                                            displayedTemplates.map(template => (
                                                <TemplateCard
                                                    key={template.id}
                                                    template={template}
                                                    t={t}
                                                    language={language}
                                                />
                                            ))
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </section>

                <ForkTemplateModal
                    isOpen={showForkModal}
                    toggle={this.toggleForkModal}
                    officialTemplates={officialTemplates}
                    allAgencyClients={this.state.allAgencyClients}
                    loadingClients={this.state.loadingClients}
                    onForkSuccess={this.handleForkSuccess}
                />
            </div>
        );
    }
}

export const TemplateLibraryPage = withTranslation()(withRouterParams(TemplateLibraryPageClass));
